import React, { useEffect, useRef, useState } from 'react';

// Mirrors the export geometry in utils/exportPptx.js: a 13.33in-wide 16:9
// slide leaves 12.13in of content width and ~5.9in of content height below
// the section header bar. Mapping the app slide's pixel width onto that
// content width gives the approximate vertical distance one exported slide
// can hold.
const CONTENT_HEIGHT_TO_WIDTH = 5.9 / 12.13;

/**
 * Overlay that draws dashed horizontal lines showing (approximately) where
 * the PowerPoint export will cut the current app slide into 16:9 slides.
 * Renders inside a `position: relative` container and measures it.
 */
const SlideAspectGuides = () => {
    const ref = useRef(null);
    const [size, setSize] = useState({ width: 0, height: 0 });

    useEffect(() => {
        const el = ref.current?.parentElement;
        if (!el || typeof ResizeObserver === 'undefined') return undefined;
        const observer = new ResizeObserver((entries) => {
            const rect = entries[0]?.contentRect;
            if (rect) setSize({ width: rect.width, height: rect.height });
        });
        observer.observe(el);
        return () => observer.disconnect();
    }, []);

    const step = size.width * CONTENT_HEIGHT_TO_WIDTH;
    const cuts = [];
    if (step > 40 && size.height > step) {
        for (let y = step; y < size.height - 24; y += step) {
            cuts.push(y);
        }
    }

    return (
        <div ref={ref} className="slide-aspect-guides" aria-hidden="true">
            {cuts.map((y, index) => (
                <div key={index} className="slide-aspect-guides__line" style={{ top: `${Math.round(y)}px` }}>
                    <span className="slide-aspect-guides__label">
                        16:9 cut-off — PPTX slide {index + 2} starts here (approx.)
                    </span>
                </div>
            ))}
            {cuts.length === 0 && step > 40 && (
                <div className="slide-aspect-guides__fits">
                    <span className="slide-aspect-guides__label slide-aspect-guides__label--ok">
                        ✓ Fits one 16:9 slide
                    </span>
                </div>
            )}
        </div>
    );
};

export default SlideAspectGuides;
